import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Добавить блок")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Удалить")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-h6" }, "Добавить блок", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-h6" }, "Укажите этаж", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", {
    onDrop: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.onDrop($event), _ctx.isHovered = false), ["prevent"])),
    onDragover: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.isHovered = true), ["prevent"])),
    onDragleave: _cache[11] || (_cache[11] = ($event: any) => (_ctx.isHovered = false, _ctx.pointID = null))
  }, [
    _createElementVNode("span", {
      onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.askPoints && _ctx.askPoints(...args)), ["stop"]))
    }, [
      (_ctx.facilityNodesState.selectedSpace === _ctx.space?.id_space)
        ? (_openBlock(), _createBlock(_Teleport, {
            key: 0,
            to: ".selectedSpace"
          }, [
            _createVNode(_component_q_icon, {
              name: "space_dashboard",
              size: "20px"
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.space?.number_space), 1)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_q_icon, {
        name: "space_dashboard",
        size: "20px"
      }),
      _createTextVNode(" " + _toDisplayString(_ctx.space?.number_space) + " ", 1),
      _createVNode(_component_q_menu, {
        "touch-position": "",
        "context-menu": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_list, {
            dense: "",
            style: {"min-width":"100px"}
          }, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_q_item, { clickable: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.showAddPointModal = true;})
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, [
                        _createVNode(_component_q_icon, { name: "add" }),
                        _hoisted_1
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })), [
                [_directive_close_popup]
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_q_item, { clickable: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.confirm = true;})
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, [
                        _createVNode(_component_q_icon, { name: "delete" }),
                        _hoisted_2
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })), [
                [_directive_close_popup]
              ]),
              _createVNode(_component_q_separator),
              _withDirectives((_openBlock(), _createBlock(_component_q_item, { clickable: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_icon, {
                        name: "cancel",
                        class: "q-mx-auto"
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })), [
                [_directive_close_popup]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.showAddPointModal,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showAddPointModal) = $event)),
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"min-width":"350px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_q_form, { class: "q-gutter-md" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_input, {
                  filled: "",
                  type: "number",
                  modelValue: _ctx.floors,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.floors) = $event)),
                  label: "Этажей"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_q_input, {
                  filled: "",
                  type: "text",
                  modelValue: _ctx.namePoint,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.namePoint) = $event)),
                  label: "Название блока"
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", null, [
                  _createVNode(_component_q_btn, {
                    label: "Добавить",
                    type: "submit",
                    color: "primary"
                  }),
                  _withDirectives(_createVNode(_component_q_btn, {
                    label: "Отмена",
                    color: "primary"
                  }, null, 512), [
                    [_directive_close_popup]
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.setFloorModal,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.setFloorModal) = $event)),
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"min-width":"350px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_q_form, {
              onSubmit: _ctx.bindPoint,
              class: "q-gutter-md"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_input, {
                  filled: "",
                  type: "number",
                  modelValue: _ctx.floors,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.floors) = $event)),
                  label: "Этаж"
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", null, [
                  _createVNode(_component_q_btn, {
                    label: "Связать",
                    type: "submit",
                    color: "primary"
                  }),
                  _withDirectives(_createVNode(_component_q_btn, {
                    label: "Отмена",
                    color: "primary"
                  }, null, 512), [
                    [_directive_close_popup]
                  ])
                ])
              ]),
              _: 1
            }, 8, ["onSubmit"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.confirm,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.confirm) = $event)),
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_actions, null, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  label: "Отмена",
                  color: "primary"
                }, null, 512), [
                  [_directive_close_popup]
                ]),
                _createVNode(_component_q_btn, {
                  flat: "",
                  label: "Удалить",
                  color: "negative",
                  onClick: _ctx.removeSpace
                }, null, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 32))
}